import SubtleBadge from "components/common/SubtleBadge";
import useFormattedDate from "hooks/useFormatDate";
import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

export const ClientIDDetailsModal = ({
  selectedID,
  loading,
  showModal,
  setShowModal,
}) => {
  const {formatDateTime} = useFormattedDate();
  const [type, setType] = useState("");
  const [label, setLabel] = useState("");

  useEffect(() => {
    if (!selectedID?.status) return;

    const statusMap = {
      ACTIVE: { type: "success", label: "ACTIVE" },
      NEW: { type: "primary", label: "NEW" },
      BLOCKED: { type: "danger", label: "BLOCKED" },
      SUSPENDED: { type: "warning", label: "SUSPENDED" },
      INACTIVE: { type: "secondary", label: "INACTIVE" },
      RATE_LIMITED: { type: "info", label: "RATE LIMITED" },
      THROTTLED: { type: "dark", label: "THROTTLED" },
      DELETED: { type: "danger", label: "DELETED" },
    };

    const { type, label } = statusMap[selectedID?.status];
    setType(type);
    setLabel(label);
  }, [selectedID]);
  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      className="modal-small-text"
    >
      <Modal.Header className="py-3 fw-bold" style={{ fontSize: 14 }}>
        Client ID Details
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.8rem" }}>
        {loading ? (
          <Spinner animation="border" variant="success" />
        ) : selectedID ? (
          <>
            <p>
              <strong>Client ID:</strong> {selectedID.id}
            </p>
            <p>
              <strong>API Key:</strong> {selectedID.apiKeyId}
            </p>
            <div className="d-flex gap-2 mb-3">
              <strong>Status:</strong>{" "}
              <SubtleBadge pill bg={type}>
                {label}
              </SubtleBadge>
            </div>
            <p>
              <strong>CreatedAt:</strong>{" "}
              {formatDateTime(selectedID.createdAt)}
            </p>

            <p>
              <strong>UpdatedAt:</strong>{" "}
              {formatDateTime(selectedID.updatedAt) || "NULL"}
            </p>

            <p>
              <strong>UpdatedBy:</strong> {selectedID.updatedBy || "NULL"}
            </p>
          </>
        ) : (
          <p>No data</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          size="sm"
          variant="secondary"
          onClick={() => setShowModal(false)}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
